import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = (props) => ({
    upAndRunningContainer: css({
        position: 'relative',
        boxSizing: 'border-box',
        padding: '16px',
        backgroundColor: Color.neutral[100],
        width: '330px',
    }),
    upAndRunningContainerIsDraggingOver: css({
        position: 'relative',
        boxSizing: 'border-box',
        padding: '16px',
        backgroundColor: Color.neutral[200],
        width: '330px',
        height: 'fit-content',
        marginLeft: '6px',
        marginRight: '6px',
    }),
    dragAndDropPlaceholderText: css({
        width: '100%',
        paddingTop: '35px',
        paddingBottom: '25px',
        textAlign: 'center',
    }),
    timelineInputContainer: css({
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '20px',
    }),
    functionBoxCollectionNoteActionsContainer: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '12px',
        "& svg": {
            width: '24px',
            height: '24px',
        },
    }),
    functionCollectionNoteActionsContainer: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    }),
});
